import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app';
import { getFirestore, type Firestore } from 'firebase/firestore';

// App nomeado ("blog") — projeto Firebase separado do principal (ver conectar.md,
// spec do blog: "Firebase separado... não alterar/migrar a estrutura existente").
// Nunca usar `getApps()[0]` aqui: esse padrão (usado em src/lib/firebase.ts) é
// cego a nome e devolveria o app do projeto PRINCIPAL se ele já tiver sido
// inicializado antes (ordem de import não é garantida).
const APP_NAME = 'blog';

const requiredEnvKeys = [
  'VITE_FIREBASE_BLOG_API_KEY',
  'VITE_FIREBASE_BLOG_AUTH_DOMAIN',
  'VITE_FIREBASE_BLOG_PROJECT_ID',
] as const;

export function isBlogFirebaseConfigured(): boolean {
  return requiredEnvKeys.every((key) => {
    const value = import.meta.env[key];
    return typeof value === 'string' && value.length > 0;
  });
}

let app: FirebaseApp | undefined;
let blogDb: Firestore | undefined;

if (isBlogFirebaseConfigured()) {
  const existing = getApps().find((a) => a.name === APP_NAME);
  app = existing ?? initializeApp(
    {
      apiKey: import.meta.env.VITE_FIREBASE_BLOG_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_BLOG_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_BLOG_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_BLOG_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_BLOG_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_BLOG_APP_ID,
    },
    APP_NAME
  );
  blogDb = getFirestore(app);
}

/** Só pra debug/testes — a maioria do código deve importar `blogDb` direto. */
export function getBlogApp(): FirebaseApp {
  return getApp(APP_NAME);
}

export { blogDb };
